<template>
    <card-seplag titulo="Cadastro de Perfis">    
        <table-seplag 
            :dados.sync="perfis.content" 
            :totalRegistro="perfis.totalElements"
            :exibirCabecalho="false" 
            :campos="camposTabelaBens" 
            hasEventoAcao
            :onExcluirDado="deletarDadosTabelaBens"
            :onEditarDado="(dados)=>modalPerfil({...dados})" 
            :onAdicionarDado="() =>modalPerfil()" 
            :onSearch="search"
            paginacao
            placeholder="Digite sua pesquisa"
        >
           
        </table-seplag>
        
        
        <Dialog 
            :header="nomeDialogo" 
            :visible.sync="exibirModalPerfil" 
            :modal="true" 
            :contentStyle="'max-width:60rem;'"
        >  
            <div class="p-grid p-fluid">
                <div class="p-col-12">
                    <TabView>
                        <TabPanel header="Cadastro">  
                           <TabPanelCadastro :registro="registro"/>  
                        </TabPanel>

                        <TabPanel header="Autorizações">  
                            <TabPanelAutorizacao 
                                :parmAutorizacaoSelecionada.sync="registro.autorizacoes"
                                @update:autorizacoeSelecionada="atualizarRegistro"
                            />
                        </TabPanel>

                    </TabView>
                </div>
                <div class="p-col-12">
                    
                </div>
                <div class="p-col-4 p-md-4" v-if="!registro.id">
                    <Button label="Cadastrar" class="p-button-info" icon="pi pi-check" @click="cadastrar()"/>
                </div>
                <div class="p-col-4 p-md-4" v-if="registro.id">
                    <Button label="Editar" class="p-button-warning" icon="pi pi-user-edit"  @click="atualizarPerfil()"/>
                </div>
            </div>
        </Dialog>
    </card-seplag> 
</template>

<script>
import CardSeplag from '@/template/CardSeplag.vue'
import { baseApiUrl,printToast } from '@/config/global'
import TableSeplag from '@/template/TableSeplag.vue';
import TabPanelCadastro from './TabPanelCadastro.vue'
import TabPanelAutorizacao from './TabPanelAutorizacao.vue'

const getCadastroPerfil = () => {
    return { 
        id:null,
        nomePerfilAcesso: null,
        nivelAcesso: null,
        filtroVisualizacao: null,
        autorizacoes: [],
        autorizacoesSelecionada: []
    }
}

export default {
    name: 'cadastroPerfilUsuario',
     components: { CardSeplag,TableSeplag, TabPanelCadastro, TabPanelAutorizacao },    
    data: function(){
        return{
            camposTabelaBens:[                
                {nome:'nomePerfilAcesso', titulo: 'Perfil de Acesso'},
                {nome:'sistema.nomeSistema', titulo: 'Sistema'},
            ],
            perfis:  {content:[]},
            perfilSelecionado: null,
            nomeDialogo: "Novo Cadastro",
            registro: getCadastroPerfil(),
            exibirModalPerfil: false
        }
    },
    methods:{
        carregarDados(){ 
          this.$http.get(`${baseApiUrl}/seguranca/perfilacessos/all?size=10&page=0`).then(res1=>{
              this.perfis = res1.data              
          })
        },
        modalPerfil(dados=null){
            
            if(dados){
                this.nomeDialogo = "Editar Cadastro"
                this.registro = {...dados}  

            }else{
                this.registro = getCadastroPerfil()
                this.nomeDialogo = "Novo Cadastro"
            }
             
            this.exibirModalPerfil = true
        },
        onPageAutorizacoes(event){
            this.$http.post(`${baseApiUrl}/seguranca/autorizacaos?page=${event.page}&size=10`)
            .then(res => {
                this.autorizacoes = res.data
            })
        },
        deletarDadosTabelaBens(elemento){
            this.$http.delete(`${baseApiUrl}/seguranca/perfilacessos/${elemento.id}`)
                .then(() =>{
                    printToast({
                    severity: "success",
                    summary: "Perfil Excluido",
                    detail: `O perfil de acesso: ${elemento.nomePerfilAcesso} foi excluido com sucesso`
                    })
                    this.registro = getCadastroPerfil()
                    this.exibirModalPerfil = false
                    this.carregarDados()
                })

        },
        atualizarPerfil(){
            this.$http.put(`${baseApiUrl}/seguranca/perfilacessos/${this.registro.id}`,JSON.stringify(this.registro))
                .then(() =>{

                    printToast({
                    severity: "success",
                    summary: "Perfil Alterado",
                    detail: "Perfil alterado com sucesso"
                    })
                    this.registro = getCadastroPerfil()
                    this.exibirModalPerfil = false
                    this.carregarDados()
                })

        },
        cadastrar(){
            this.$http.post(`${baseApiUrl}/seguranca/perfilacessos`,JSON.stringify(this.registro))
                .then(() =>{1
                    printToast({
                    severity: "success",
                    summary: "Perfil inserido",
                    detail: "Perfil inserido com sucesso"
                    })
                    this.registro = getCadastroPerfil()
                    this.exibirModalPerfil = false 
                    this.carregarDados() 
                })
        },
        atualizarRegistro(event){
            this.registro.autorizacoes = event
        },
        search(filtro){
			if(filtro != ''){
				this.$http.get(`${baseApiUrl}/seguranca/perfilacessos/all/${filtro}`).then(res => {
					this.perfis = res.data
				})
			}else{
				this.$http.get(`${baseApiUrl}/seguranca/perfilacessos/all?size=10&page=0`).then(res1=>{
					this.perfis = res1.data
				})
			}
		},

    },
    mounted(){
        this.carregarDados()
    },

}
</script>

<style lang="scss" scoped>
    .p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
        display: none;
    }

    @media screen and (max-width: 40em) {
        /deep/ .p-datatable {
            &.p-datatable-responsive-demo {
                .p-datatable-thead > tr > th,
                .p-datatable-tfoot > tr > td {
                    display: none !important;
                }

                .p-datatable-tbody > tr > td {
                    text-align: left;
                    display: block;
                    width: 100%;
                    float: left;
                    clear: left;
                    border: 0 none;

                    .p-column-title {
                        padding: .4rem;
                        min-width: 30%;
                        display: inline-block;
                        margin: -.4em 1em -.4em -.4rem;
                        font-weight: bold;
                    }

                    &:last-child {
                        border-bottom: 1px solid var(--surface-d);
                    }
                }
            }
        }
    }
</style>